import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { LayerBottom, Button } from 'components'
import styles from './index.module.css'
import Swiper from 'css/Swiper.module.css'
import Lib from 'library'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { influencerState } from './states'
import DetailTip from 'views/mydata/common/DetailTip'

const Participate = () => {

	const App = useApp()
	const navigate = useNavigate()
	const location = useLocation();

	const moreSliceN = 5;  // 더보기 버튼 초기 개수
	const [subscribeInfl, setSubscribeInfl] = useState() // 구독한 인플루언서 목록
	const [inflLankData, setInflLankData] = useState()  // 구독수가 많은 인플루언서
	const [influMoreBtn, setInfluMoreBtn] = useState(moreSliceN)  // 현재 보여지는 더보기 버튼 리스트
	const [influLength, setInfluLength] = useState(0)  // 더보기 버튼 index
	const myInfoData = useRecoilValue(influencerState) // 유저 정보
	const [realTimeChange, setRealTimeChange] = useState(false)  // 구독하기,취소하기 클릭시 변경된 상태로 리렌더링
	const [detailTip, setDetailTip] = useState(false) //활동정지안내 하단 레이어

	useEffect(() => {
		console.log(location.state);
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={() => {location.state?.from ? navigate(location.state?.from) : navigate(-1)}} />,
			right: <i className="icon icon_question icon_question--dark" onClick={() => clickIntro()} />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	const clickIntro = () => {
		navigate("/home/influencerIntro")
	}

	//활동정지 하단 레이어
	const openDetail = () => {
		setDetailTip(true)
	}
	const closeDetail = () => {
		setDetailTip(false)
	}

	//  구독한 인플루언서 목록
	useEffect(() => {
		Lib.post(`/api/infl/lst/sbscr`, {
			cnt: ''
		}, data => {
			setSubscribeInfl(data);
		})
	}, [realTimeChange])

	// 구독수가 많은 인플루언서
	useEffect(() => {
		Lib.post(`/api/infl/lst/rank`, data => {
			setInfluLength(Math.ceil(data.length / moreSliceN));
			setInflLankData(data.slice(0, influMoreBtn))
		})
	}, [influMoreBtn, realTimeChange])

	// 더보기 버튼
	const influMoreButton = () => {
		setInfluMoreBtn(influMoreBtn + moreSliceN)
	}

	const influMorebtnBox = () => {
		if (influLength > 1 && (influMoreBtn / moreSliceN) < influLength) {
			return (
				<div className="padding pb_50" onClick={influMoreButton}>
					{/* <Button className="btn btn--big btn-more">+ 더보기</Button> */}
					<Button className="btn btn--big">+ 더보기</Button>
				</div>
			)
		} else {
			return ''
		}
	}

	// 구독 취소하기
	const onSbscCancle = (item) => {
		Lib.post(`/api/infl/unsbscr`, {
			unsbscrMbId: item.mbId
		}, data => {
			setRealTimeChange(!realTimeChange)
		})

	}

	// 구독하기
	const onSbsc = (item) => {
		Lib.post(`/api/infl/sbscr`, {
			sbscrMbId: item.mbId
		}, data => {
			setRealTimeChange(!realTimeChange)
		})
	}

	// 유저 인플루언서 상세보기
	const onDetailView = (item) => {
		Lib.post(`/api/infl/inf`, {
			mbId: item.mbId
		}, data => {
			if (data.joinYn === 'N') {
				App.showAlert("해당 유저는 인플루언서 미참여 상태입니다.")
			} else if (data.mbStusCd === 'DRMNC') {
				App.showAlert("해당 유저는 휴먼 상태입니다.")
			} else if (data.mbStusCd === 'WTHDR') {
				App.showAlert("해당 유저는 탈퇴 상태입니다.")
			} else {
				if (item.mbId === App.user?.mbId) {
					navigate("/home/influencerMy", {
						state: {
							mbIdData: item,
							otherMbIdData: myInfoData,
						}
					})
				} else {
					navigate("/home/InfluencerOthers", {
						state: {
							mbIdData: item,
							otherMbIdData: myInfoData,
						}
					})
				}
			}
		})
	}

	// 구독중인 인플루언서 더보기
	const oninfluMore = () => {
		navigate("/home/influencerMy", {
			state: {
				influMore: false,
			}
		})
	}

	const onRouterDetail = () => {
		navigate("/home/influencerMy")
	}

	return (
		<div className="page">
			{myInfoData && (
				<div className="shadow">
					<div className="padding">
						<div className="flex-justify_between">
							<div className="flex-align_center" onClick={onRouterDetail}>
								<div className="img-box user-profile profile_60">
									{myInfoData && (
										<img src={"/images/profile/influencer_profile" + myInfoData.prflCd + ".svg"} alt="프로필 이미지" />
									)}
								</div>
								{myInfoData.stopYn === 'Y' ?
									<h4 className="ml_10"><strong>{myInfoData.ncknm}</strong>님!<br />관리자에 의해 활동이 정지되었습니다</h4>
									:
									<h4 className="ml_10"><strong>{myInfoData.ncknm}</strong>님!<br />구독중인 인플루언서를 구경해볼까요?</h4>
								}
							</div>
							{myInfoData.stopYn === 'Y' &&
								<i className="icon icon_mark_circle" onClick={openDetail} />
							}
						</div>
					</div>
				</div>


				// <Link to="/home/influencerMy">
				// </Link>
			)}
			{subscribeInfl && subscribeInfl.length > 0 ?
				<div className="shadow">
					<div className="padding">
						<h3>구독중인 인플루언서</h3>
						<div className={`${Swiper.ScrollArea} mt_20`}>
							<ul className={Swiper.slider}>
								{subscribeInfl.map((item, index) => {
									if (index === 9) {
										return (
											<>
												<li key={index} className={item.newYn === 'Y' ? Swiper.noti : ''} >
													<div className="img-box user-profile profile_60" onClick={() => onDetailView(item)}>
														<img src={"/images/profile/influencer_profile" + item.prflCd + ".svg"} alt="프로필 이미지" />
													</div>
													<span className="ellipsis">{item.ncknm}</span>
												</li>
												<li onClick={() => oninfluMore()}>
													<div className={`${Swiper.more} user-profile profile_60`}>
														+
													</div>
													<span>+ 더보기</span>
												</li>
											</>
										)
									} else if (index >= 10) {
										return false
									} else {
										return (
											<li key={index} className={item.newYn === 'Y' ? Swiper.noti : ''}>
												<div className="img-box user-profile profile_60" onClick={() => onDetailView(item)}>
													<img src={"/images/profile/influencer_profile" + item.prflCd + ".svg"} alt="프로필 이미지" />
												</div>
												<span className="ellipsis">{item.ncknm}</span>
											</li>
										)
									}
								})}
							</ul>
						</div>
					</div>
				</div>
				: ''}
			{inflLankData &&
				<>
					{inflLankData.length > 0 ?
						<>
							<h3 className="padding pb_20">구독수가 많은 인플루언서</h3>
							<ul className={`${styles["influencer-list"]} list-bg`}>
								{inflLankData.map((item, index) => {
									let cssMedal = '';
									if (index === 0) cssMedal = 'icon_medal_gold'
									if (index === 1) cssMedal = 'icon_medal_silver'
									if (index === 2) cssMedal = 'icon_medal_bronze'
									return (
										<li key={index}>
											<div className="flex-align_center" onClick={() => onDetailView(item)}>
												<span className={styles.number}>{item.rank}</span>
												<div className="flex-align_center ml_20">
													<div className={styles["user"]}>
														<div className="img-box user-profile profile_50">
															<img src={"/images/profile/influencer_profile" + item.prflCd + ".svg"} alt="프로필 이미지" />
														</div>
														<i className={`icon ${cssMedal}`} />
													</div>
													<div className={`${styles.profile} ml_10`}>
														<p>{item.ncknm}</p>
														<span className="flex-align_center mt_5"><span className="text-blue">{item.sbscrCnt}명</span>이 구독중</span>
													</div>
												</div>
											</div>
											{myInfoData && myInfoData.mbId === item.mbId ? '' : item.sbscrYn === 'Y' ? <span className={`${styles.choose} ${styles.cancel}`} onClick={() => onSbscCancle(item)}>구독취소</span> : <span className={`${styles.choose}`} onClick={() => onSbsc(item)}>+ 구독하기</span>}
										</li>
									)
								})}
							</ul>
							{influMorebtnBox()}
						</>
						:
						<>
							{/* 데이터 없을 때 */}
							<div className="center-cont py_80">
								<i className="icon_influencer_smile" />
								<p className="mt_15" style={{ fontSize: "1.6rem" }}>첫번째 인플루언서가<br />되어보세요!</p>
							</div>
						</>
					}
				</>
			}
			<DetailTip title="관리자에 의해 활동정지 되었어요!" show={detailTip} closeLayer={closeDetail} content={
				<ul className="list-item" style={{ fontSize: "1.4rem" }}>
					<li>
						<span>정지일</span>
						<span>{myInfoData && Lib.dateFormat(myInfoData.stopStDe, ".")}</span>
					</li>
					<li>
						<span>정지사유</span>
						<span>{myInfoData && myInfoData.stopRsn}</span>
					</li>
					<li>
						<span>해제일</span>
						<span>{myInfoData && Lib.dateFormat(myInfoData.stopRlsDe, ".")} (D-{myInfoData && Lib.getDday(Lib.GetServerDate(), Lib.ChanageNewDate(myInfoData.stopRlsDe))})</span>
					</li>
				</ul>
			} />
		</div>
	)
}

export default Participate
